Gift = require '../../../gift_button/frontend/gift'

window.MultiOptionModal ?= {}

MultiOptionModal.init = (payload, done) ->
  return done() unless payload?.buyButton.multiOptionEnabled

  openMultiOptionModal = (e) ->
    $modal = $ '#options'
    return unless $modal.length

    if $modal.hasClass 'tooltip'
      $tooltipTrigger = if e?.delegateTarget
        $ e.delegateTarget
      else if Gift.cookieCreated
        $ '.gift-button'
      else
        $ '.buy-button'

      $tooltipTrigger.attr
        'data-position': 'bottom'
        'data-tooltip-id': 'options'
        'data-trigger-event': 'js-trigger'

      $tooltipTrigger.find('.tooltip-target').attr('data-position', 'bottom')

      GIG.Tooltip.helpers.tooltip.apply $tooltipTrigger[0], [{preventDefault: ->}]

    else
      return if $modal.hasClass 'show-modal'
      return if  $(".header-row-sticky").is(":visible") and not payload.buyButton.multiOptionInline

      unless BuyButton.view.$multiOptions.filter('.selected').length
        firstAvailableOption = BuyButton.view.$multiOptions.not(":disabled")[0]
        BuyButton.view.updateMultiOptionBreakoutButton currentTarget: firstAvailableOption

      GIG.Modal.open(el: $modal)

    {stopTheBus: true}

  if payload.buyButton.multiOptionInline
    BuyButton.eventBus.board('view_options_clicked', openMultiOptionModal)
  else
    BuyButton.eventBus.board('buy_button_clicked', openMultiOptionModal)(998)

  $ ->
    $triggers = $(".show-multi-option-modal")
    $triggers.click openMultiOptionModal
    $tooltipCloser = $('.tooltip-close.icon-x')

    if $tooltipCloser.length > 0
      $tooltipCloser.off('click')
      $tooltipCloser.on('click', GIG.Tooltip.helpers.hideTooltip)

    GIG.Modal.onClose Gift.removeCookie, 'options'

    $('#options').on 'click', '.tooltip-close', Gift.removeCookie

    done()


module.exports = MultiOptionModal



// WEBPACK FOOTER //
// ./modules/buy_button/desktop_2016/frontend/multi_option_modal.coffee